import React, { Fragment, useEffect, useMemo, useState } from 'react'
import ExportExcelButton from "../../components/exportExcelButton";
import { useDispatch, useSelector } from 'react-redux';
import { getSession, processInt } from '../../global';
import { saveAdvice } from '../../services/shipperadviceservice';
import { setLoading } from '../../redux/appSlice';
import { setGrid, updateGrid, removeGridItem } from '../../redux/shipperAdviceSlice';
import TicketDetail from './ticketdetail';
import Pagination from '../../components/paginations2';

const Grid = () => {
    const dispatch = useDispatch();
    const {
        data, grid, calltracks, reattempts, originalGrid
    } = useSelector(state => state.shipperAdviceData);

    const updateData = (index, key, val) => {
        dispatch(updateGrid({ index, key, val }))
    }

    const [page, setPage] = useState(0);
    const [pageLimit, setPageLimit] = useState(50);
    const [sortConfig, setSortConfig] = useState({ key: null, direction: 'ascending' });

    const searchObjInit = {
        ticketNo: '',
        cn: '',
        callStatus: '',
        pendingReason: '',
        standardNote: '',
        destinationBranch: ''
    };

    const [searchObject, setSearchObj] = useState(searchObjInit);
    const updateSearchData = (key, val) => setSearchObj(prev => { return { ...prev, [key]: val } });
 
    
    const gridKeys = [
        {key: '', name: 'Customer Response', searchBox: false, visible: data.type == 1},
        {key: 'kpi', name: 'Remaining Response Time', searchBox: false, visible: data.type == 1},
        {key: 'callTrackName', name: 'Advice Closing Remarks', searchBox: false, visible: data.type != 1},
        {key: 'comments', name: 'Customer Remarks', searchBox: false, visible: data.type != 1},
        {key: 'ticketNo', name: 'Pending Ref No', searchBox: true, visible: true},
        {key: 'ticketDate', name: 'Pending Ref Date', searchBox: false, visible: true},
        {key: 'cn', name: 'Consignment #', searchBox: true, visible: true},
        {key: 'consigneeContact', name: 'Consignee Contact', searchBox: false, visible: true},
        {key: 'orderRefNo', name: 'Order Ref No', searchBox: false, visible: true},
        {key: 'bookingDate', name: 'Booking Date', searchBox: false, visible: true},
        {key: 'destinationBranch', name: 'Destination', searchBox: true, visible: true},
        {key: 'pendingReason', name: 'Pending Reason', searchBox: true, visible: true},
        {key: 'standardNote', name: 'Standard Note', searchBox: true, visible: true},
        {key: 'callStatus', name: 'Call Status', searchBox: true, visible: true},
        {key: 'podStatus', name: 'Status', searchBox: false, visible: true},
        {key: 'nsa', name: 'NSA/OSA Add. Charges', searchBox: false, visible: true}

    ]
    
    const requestSort = (key) => {
        let direction = 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
          direction = 'descending';
        }
        setSortConfig({ key, direction });
    };

    let filterData = useMemo(() => {
        return grid.filter((item, index) => {
            return (index >= page * pageLimit) & (index < (page + 1) * pageLimit);
        })
    }, [page, grid, pageLimit, grid.length]);

    const sortedArray = [...filterData].sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
          return sortConfig.direction === 'ascending' ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
          return sortConfig.direction === 'ascending' ? 1 : -1;
        }
        return 0;
      });

      function trimString(s) {  
        var l=0, r=s.length -1;
        while(l < s.length && s[l] == ' ') l++;
        while(r > l && s[r] == ' ') r-=1;
        return s.substring(l, r+1);
      }

    const validAdvice = (d) => {
        let x = true;
        if (d.advice == 3 && d.reattemptReason == 0) {
            alert('Reattempt Reason is required');
            x = false;
        } else if (d.advice == 3 && d.reattemptReason == 2 && (!d.consigneeContact || !d.consigneeAddress)) {
            alert('Consginee Contact and Address is required');
            x = false;
        }

        return x;
    }


    const onAdviceUpdate = async (d, index) => {
        if (validAdvice(d)) {
            const u = getSession('userInfo');
            dispatch(setLoading({ data: true }));
            const rs = await saveAdvice({ ...d, CreatedBy: u.id });
            dispatch(setLoading({ data: false }));
            if (rs.sts == 0) {
                dispatch(removeGridItem({ index: index }));
                alert('Ticket Updated');
            } else {
                alert(rs.msg);
            }
        }
    }
    
    function getIndex(key, val) {
        let objIndex = -1;
        for (let i = 0; i < grid.length; i++) {
            if (grid[i][key] === val) {
                objIndex = i;
                break;
            }
        }
        return objIndex;
    }

  const columns =
    data.type == 1
      ? [
          { label: 'Ticket No', key: 'ticketNo' },
          { label: 'Ticket Date', key: 'ticketDate' },
          { label: 'CN', key: 'cn' },
          { label: 'Consignee Contact', key: 'consigneeContact' },
          { label: 'Order RefNo', key: 'orderRefNo' },
          { label: 'Booking Date', key: 'bookingDate' },
          { label: 'Destination Branch', key: 'destinationBranch' },
          { label: 'Pending Reason', key: 'pendingReason' },
          { label: 'Standard Note', key: 'standardNote' },
          { label: 'Call Status', key: 'callStatus' },
          { label: 'KPI', key: 'kpi' },
          { label: 'Cod Amount', key: 'codAmount' },
          { label: 'Status', key: 'podStatus' },
          { label: 'NSA/OSA Add. Charges', key: 'nsa' },
        ]
      : [
          { label: 'Ticket No', key: 'ticketNo' },
          { label: 'Ticket Date', key: 'ticketDate' },
          { label: 'CN', key: 'cn' },
          { label: 'Consignee Contact', key: 'consigneeContact' },
          { label: 'Order RefNo', key: 'orderRefNo' },
          { label: 'Booking Date', key: 'bookingDate' },
          { label: 'Destination Branch', key: 'destinationBranch' },
          { label: 'Pending Reason', key: 'pendingReason' },
          { label: 'Standard Note', key: 'standardNote' },
          { label: 'Call Status', key: 'callStatus' },
          { label: 'CallTrack Name', key: 'callTrackName' },
          { label: 'Comments', key: 'comments' },
          { label: 'Cod Amount', key: 'codAmount' },
          { label: 'Status', key: 'podStatus' },
          { label: 'NSA/OSA Add. Charges', key: 'nsa' },
        ];

return <Fragment>
      <div style={{ textAlign: 'right', marginBottom: 5 }}>
        <ExportExcelButton
          data={grid}
          columns={columns}
          fileName={data.type == 1 ? 'ShipperAdvice_Regular' : 'ShipperAdvice_Closing'}
          label="Export"
        />
      </div>
        
        <Pagination
                setGrid={(result) => {
                    dispatch(setGrid({ data: result }));
                }}
                searchObjInit={searchObjInit}
                searchObject={searchObject}
                originalGrid={originalGrid} 
                setPage={setPage}
                setPageLimit={setPageLimit}
                requestSort={requestSort}
                sortConfig={sortConfig}
                updateSearchData={updateSearchData}
                data={data}
                dataCount={grid.length}
                pageLimit={pageLimit}  
                gridrender={sortedArray}
                page={page}
                grid={
                    <div className="table-responsive" style={{ height: '60vh', position: 'relative' }}>
                    <table className="table table-bordered">
                        <thead>
                            <tr>
                                <th style={{ position: 'sticky', top: 0, background: 'white', zIndex: 1000 }}>S.No</th>

                                {
                                                      gridKeys.map((e,i) => 
                                                        e.visible ?  
                                                        <th 
                                                            style={{ position: 'sticky', top: 0, background: 'white', zIndex: 1000 }}
                                                            className={e.key === '' ? "th-datatable" : "th-datatable cursor-pointer"}
                                                            onClick={() => {
                                                                requestSort(e.key === '' ? 'NoArrow' : e.key)
                                                            }}
                                                            title="Sort"
                                                            key={i}
                                                        >{e.name} 
                                                          <i 
                                                          key={i}
                                                              className={
                                                              sortConfig.key === e.key
                                                                  ? sortConfig.direction === 'ascending'
                                                                      ? 'icon-setting fa fa-arrow-down'
                                                                      : 'icon-setting fa fa-arrow-up'
                                                                  : ''
                                                              } aria-hidden="true"></i>

                                                        </th>: <></>)
                                                    }
                            </tr>
                            <tr key={'start'}>
                                <td key={'he2'}></td>
                                {gridKeys.map((g, i) => {

                                    return g.visible ?  
                                    g.searchBox ? 
                                            <td key={i}>
                                                <input type="text"  onChange={(e) => {
                                                    updateSearchData(g.key, trimString(e.target.value));
                                                }}  className="inp" placeholder={g.name} />
                                            </td> : 
                                            <td key={i}></td>
                                    : <></>
                                    })}
                            </tr>
                            {
                                sortedArray && sortedArray.length > 0 && sortedArray.map((x, index) =>
                                    <Fragment key={index}>
                                        <tr>
                                            <td>{(index + 1)+(page*pageLimit)}</td>
                                             {
                                                data.type == 1 ?
                                                    <Fragment>
                                                        <td>
                                                            <select className="form-select" style={{ width: 200 }} value={x.advice} onChange={(e) => {
                                                                if (e.target.value == x.tempAdvice) {
                                                                    alert('This option is already once selected');
                                                                } else {
                                                                    updateData(getIndex('cn', x.cn), 'advice', e.target.value)
                                                                }
                                                            }}>
                                                                <option value="0">Select Advice</option>
                                                                {
                                                                    calltracks.map((c, index2) => <option key={index2} value={c.value}>{c.text}</option>)
                                                                }
                                                            </select>
                                                        </td>
                                                        <td style={{fontWeight: 'bold', color: '#EA5B0C'}}>{x.kpi}</td>
                                                    </Fragment> :
                                                    <Fragment>
                                                        <td>{x.callTrackName}</td>
                                                        <td>{x.comments}</td>
                                                    </Fragment>
                                            }
                                            <td><span style={{ color: '#EA5B0C', cursor: 'pointer' }} onClick={() => {
                                                updateData(getIndex('cn', x.cn), 'showDetail', !x.showDetail)
                                            }}>{x.ticketNo}</span></td>
                                            <td>{x.ticketDate}</td>
                                            <td><span style={{ color: '#EA5B0C', cursor: 'pointer' }} onClick={(e) => {
                                                e.preventDefault();
                                                sessionStorage.setItem('cn', x.cn);
                                                window.open('/cplight/tracking_2', '_blank');
                                            }}>{x.cn}</span></td>
                                            <td>{x.consigneeContact}</td>
                                            <td>{x.orderRefNo}</td>
                                            <td>{x.bookingDate}</td>
                                            <td>{x.destinationBranch}</td>
                                            <td>{x.pendingReason}</td>
                                            <td>{x.standardNote}</td>
                                            <td>{x.callStatus}</td>
                                            <td>{x.podStatus}</td>
                                            <td>{x.nsa}</td>
                                        </tr>
                                        {
                                            x.advice > 0 && data.type == 1 &&
                                            <tr>
                                                <td colSpan={14}>
                                                    <div className="row p-2" style={{ background: 'rgba(0,0,0,0.04)' }}>
                                                        {
                                                            x.advice == 3 &&
                                                            <Fragment>
                                                                <div className="col-2">
                                                                    <label>Re Attempt Reason</label>
                                                                    <select className="form-select" value={x.reattemptReason} onChange={(e) => {
                                                                            updateData(getIndex('cn', x.cn), 'reattemptReason', e.target.value)
                                                                        }}>
                                                                        <option value="0">Select Re Attempt Reason</option>
                                                                        {
                                                                            reattempts.map((c, index2) => <option key={index2} value={c.value}>{c.text}</option>)
                                                                        }
                                                                    </select>
                                                                </div>
                                                                {
                                                                    (x.reattemptReason == 1 || x.reattemptReason == 2) &&
                                                                    <Fragment>
                                                                        <div className="col-2">
                                                                            <label>Consignee Phone Number</label>
                                                                            <input type="text" className="form-control" readOnly={x.reattemptReason == 1} value={x.consigneeContact} onInput={processInt} onChange={(e) => updateData(getIndex('cn', x.cn), 'consigneeContact', e.target.value)} />
                                                                        </div>
                                                                        <div className="col-2">
                                                                            <label>Consignee Address</label>
                                                                            <textarea type="text" className="form-control" readOnly={x.reattemptReason == 1} value={x.consigneeAddress} onChange={(e) => updateData(getIndex('cn', x.cn), 'consigneeAddress', e.target.value)}></textarea>
                                                                        </div>
                                                                    </Fragment>
                                                                }
                                                            </Fragment>
                                                        }
                                                        <div className="col-2">
                                                            <label>Remarks</label>
                                                            <textarea className="form-control" value={x.comments} onChange={(e) => updateData(getIndex('cn', x.cn), 'comments', e.target.value)}></textarea>
                                                        </div>
                                                        <div className="col-2">
                                                            <button type="button" className="btn btn-sm btn-primary" style={{ marginTop: 24 }} onClick={async () => onAdviceUpdate(x, getIndex('cn', x.cn))}>Update</button>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        }
                                        {
                                            x.showDetail && <TicketDetail data={x} />
                                        }
                                    </Fragment>
                                )
                            }
                        </thead>
                    </table>
                    </div>
                }
        />
    </Fragment>
}

export default Grid;
